import { combineReducers } from '@reduxjs/toolkit';
import { sendToSpruceSlice, taxCertificationRequestsSlice, updateVendorTaxCertificationSlice } from './slices';
import { taxCertificationSlice } from '../../order/taxCertifications/taxCertificationSlice';

export const taxCertificationReducer = combineReducers({
  sendToSpruceSlice: sendToSpruceSlice.reducer,
  taxCertificationRequestsSlice: taxCertificationRequestsSlice.reducer,
  taxCertificationSlice: taxCertificationSlice.reducer,
  updateVendorTaxCertificationSlice: updateVendorTaxCertificationSlice.reducer,
});
